/**
 * Episode resolve client — Hub deep-link path for series resumes.
 *
 * The continue-watching strip on the Hub stores `(series_id, episode_id)`
 * but no playable URL. When the user clicks a series card, this helper
 * round-trips to the backend to re-hydrate the URL + metadata so the
 * watch route can mount straight in.
 *
 * 404 → fall back to series-detail navigation.
 *
 * Spec: docs/superpowers/specs/2026-05-10-hub-overlay-and-deep-links.md §4.
 */
import { api } from "./api";

export interface EpisodeResolveOut {
  series_id: string;
  episode_id: string;
  season: number | null;
  episode_num: number | null;
  title: string;
  parent_title: string;
  poster: string | null;
  direct_url: string;
  proxy_url: string;
  container: string | null;
  duration_secs: number | null;
}

export const Episodes = {
  resolve: (pid: number, seriesId: string, episodeId: string) =>
    api
      .get<EpisodeResolveOut>(
        `/api/playlists/${pid}/series/${encodeURIComponent(seriesId)}/episodes/${encodeURIComponent(episodeId)}/resolve`,
      )
      .then((r) => r.data),
};
